const initialState = {
  list: {
    isLoading: false,
    error: '',
    paginationOptions: {
      page: 1,
      size: 20,
      value__contains: '',
    },
    data: {
      items: [],
      count: 0,
    },
  },
  add: {
    isLoading: false,
    error: '',
  },
  update: {
    isLoading: false,
    error: '',
  },
  delete: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
